/**
 *
 * @class sgvizler.Core
 * @memberof sgvizler
 */
export class Core {
    /**
     * todo
     * @returns {string}
     */
    static get path() {
        return this._path;
    }
    /**
     * todo
     * @param {string} value
     */
    static set path(value) {
        this._path = value;
    }
}
/**
 * The version number of this sgvizler2.
 * @static
 * @readonly
 * @type {string} VERSION
 */
Core.VERSION = '0.0';
/**
 * sgvizler2's homepage.
 * @static
 * @readonly
 * @type {string} HOMEPAGE
 */
Core.HOMEPAGE = 'https://bordercloud.github.io/sgvizler2/index.html';
/**
 * sgvizler2's docs path
 * @static
 * @readonly
 * @type {string} DOCPATH
 */
Core.DOCPATH = 'https://bordercloud.github.io/sgvizler2/';
Core._path = '';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ29yZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9zZ3Zpemxlci9Db3JlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOzs7O0dBSUc7QUFDSCxNQUFNLE9BQU8sSUFBSTtJQUViOzs7T0FHRztJQUNILE1BQU0sS0FBSyxJQUFJO1FBQ1gsT0FBTyxJQUFJLENBQUMsS0FBSyxDQUFBO0lBQ3JCLENBQUM7SUFFRDs7O09BR0c7SUFDSCxNQUFNLEtBQUssSUFBSSxDQUFFLEtBQWE7UUFDMUIsSUFBSSxDQUFDLEtBQUssR0FBRyxLQUFLLENBQUE7SUFDdEIsQ0FBQzs7QUFFRDs7Ozs7R0FLRztBQUNvQixZQUFPLEdBQVcsS0FBSyxDQUFBO0FBRTlDOzs7OztHQUtHO0FBQ29CLGFBQVEsR0FBVyxvREFBb0QsQ0FBQTtBQUU5Rjs7Ozs7R0FLRztBQUNvQixZQUFPLEdBQVcsMENBQTBDLENBQUE7QUFFcEUsVUFBSyxHQUFXLEVBQUUsQ0FBQSJ9